export function getScheduleDatePart(val) {
  if (val == null) return null;
  if (typeof val === "string") {
    const part = val.split("T")[0].split(" ")[0];
    return /^\d{4}-\d{2}-\d{2}$/.test(part) ? part : null;
  }
  if (val instanceof Date) {
    return val.toISOString().split("T")[0];
  }
  return null;
}

export function parseScheduleDateLocal(val) {
  const part = getScheduleDatePart(val);
  if (!part) return null;
  // "YYYY-MM-DD" + "T00:00:00" (no Z) parses as local midnight
  return new Date(part + "T00:00:00");
}


export function getDisconnectScheduleDateStr(val) {
  if (val == null) return null;
  if (val instanceof Date) {
    if (Number.isNaN(val.getTime())) return null;
    return val.toISOString().split("T")[0];
  }
  if (typeof val !== "string") return null;
  const s = val.trim();
  if (!s) return null;

  return getScheduleDatePart(s);
}
